import { CommonModule } from "@angular/common";
import {
  Component,
  inject
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CardData,
  GenericCardComponent,
} from "../../../components/common/generic-card/generic-card.component";
import { LoadingComponent } from "../../../components/common/loading/loading.component";
import { EditorItemModalComponent } from "../../../components/modal-templates/generic-modal/editor-item-modal.component";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-catalogue-agentic-ai",
  standalone: true,
  imports: [CommonModule, FormsModule, GenericCardComponent, LoadingComponent],
  templateUrl: "./catalogue-agentic-ai.component.html",
  styleUrl: "./catalogue-agentic-ai.component.scss",
})
export class CatalogueAgenticAIComponent extends BaseLayoutComponent {
  userQuery: string = "";
  projectId: string = "";
  isLoading: boolean = false;
  userProfile:any;
  private modalService = inject(NgbModal);
  isActive = false;

  // Sample data - replace with your actual data source
  cardItems: CardData[] = [
    {
      title: "Write detailed functional test cases",
      description:
        "Write detailed functional test cases for a login page covering valid login, invalid credentials, and input validation scenarios",
      time: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), // 10 days ago
    },
    {
      title: "API Integration Testing",
      description:
        "Create comprehensive test cases for REST API endpoints including success, failure, and edge cases",
      time: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    },
    {
      title: "Database Query Validation",
      description:
        "Test various database queries and their responses for data consistency and accuracy",
      time: new Date(), // Today
    },
    {
      title: "Write detailed functional test cases",
      description:
        "Write detailed functional test cases for a login page covering valid login, invalid credentials, and input validation scenarios",
      time: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), // 10 days ago
    },
    {
      title: "API Integration Testing",
      description:
        "Create comprehensive test cases for REST API endpoints including success, failure, and edge cases",
      time: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    },
    {
      title: "Database Query Validation",
      description:
        "Test various database queries and their responses for data consistency and accuracy",
      time: new Date(), // Today
    },
  ];

  onQueryChange(event: any): void {
    this.userQuery = event.target.value;
  }

  ngOnInit(): void {
    this.getAllChats();

    // Get projectId from ProjectService
    this.projectService.getProjectId().subscribe(
      (id: string | null) => {
        this.projectId = id || '';
      }
    );

    this.userProfile = this.authRealmService.getUserProfile();

  }

  sendQuery(): void {
    if (this.userQuery.trim()) {
      console.log('User query:', this.userQuery);
      this.agenticAiService.setMessage(this.userQuery);
      this.sideNav.setTreeNode("workspace");
      this.userQuery = "";
    }
  }

  getAllChats() {
    this.isLoading = true;
    this.restService
      .getAllChats(this.dataStore?.data?.id)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          console.log("all chats-->>",response);
          this.cardItems = response.data;
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error("An error occurred while retrieving chat messages:", error);
          this.toaster.pop({
            type: "error",
            text: MessageEnum.AI_GET_ALL_CHATS,
          });
        },
      });
  }

  onChatClick(card: CardData) {
    if (card.isLoading) {
      return;
    }
    card.isLoading = true;
    this.getChatHistory(card);
  }

  onEditChat(card: CardData) {
    let fields = [{
      key: "title",
      id: "title",
      name: "Chat title",
      type: "text-input",
      value: card.title,
      validations: {
        required: true,
      },
      wrapperClass: "col-md-12",
    },];
    let configs = {
      title: "Set Chat Title",
      isEdit: true,
      model:{
        title: card.title,
      }
    };
    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: "static",
    });
    modalRef.componentInstance.configs = configs;
    modalRef.componentInstance.fields = fields;

    modalRef.result.then((result) => {
      console.log("result", result);
      card.isLoading = true;

      let payload = {
        chat_title : result?.value?.title
      }
      this.restService
      .updateChatTitle(card.threadId, this.projectId, payload)
      .subscribe({
        next: (response: any) => {
          this.toaster.pop({
            type: "success",
            text: MessageEnum.UPDATING_CHAT_TITLE_SUCCESS,
          });
          card.title = result?.value?.title;
          card.isLoading = false;
        },
        error: (error: any) => {
          const errorMessage = error?.message || MessageEnum.UPDATING_CHAT_TITLE_ERROR;
          console.error("An error occurred while updating chat title:" ,error?.message);
          this.toaster.pop({
            type: "error",
            text: errorMessage,
          });
          card.isLoading = false; // Stop loading on error
        },
      });
    });
  }

  getChatHistory(card: CardData) {
    if (!card.threadId) {
      console.error("Card is missing a threadId.");
      return;
    }
    this.restService
      .getChatHistory(this.dataStore?.data?.id, card.threadId)
      .subscribe({
        next: (response: any) => {
          console.log("chats history-->>", response);
          this.aiStreamingService.clearLastChat();
          this.agenticAiService.setHistory(this.agenticAiService.processChatHistory(response));
          this.sideNav.setTreeNode("workspace");
          card.isLoading = false; // Stop loading on success
        },
        error: (error: any) => {
          console.error("An error occurred while retrieving chat history:", error);
          this.toaster.pop({
            type: "error",
            text: MessageEnum.AI_GET_ALL_CHAT_HISTORY,
          });
          card.isLoading = false; // Stop loading on error
        },
      });
  }

}
